import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Spining from '../UI/Spining/Spining';
import { BASE_URL, HOST_URL } from "../Dashboard/api/Api";
import Axios from "axios";
import MobileVerification from './MobileVerification';

const GoogleLogin = () => {
  const location = useLocation();
  const [token, setToken] = useState("");
  const [showMobileVerification, setShowMobileVerification] = useState(false);
  const [loginMessage, setLoginMessage] = useState('');
  const [bgColor, setBgColor] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  
  const [redirectAfterLogin, setRedirectAfterLogin] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
console.log(code);

    const LoginHandle = async (data) => {
      const jwtToken = data;


      setToken(jwtToken)
      try {
        const response = await Axios.post(`${HOST_URL}/login_socialmedia.php`, {
          method: 'gmail_login',
          jwt_token: jwtToken,
        });
        const responseData = response.data;


        if (responseData.success) {
          localStorage.setItem('login', JSON.stringify(responseData));
          localStorage.setItem('admin', JSON.stringify({ success: false }));

          const redirectTo = redirectAfterLogin || "/dashboard";
          setTimeout(() => {
            if (redirectTo === "/dashboard/whatsapp-onboarding-new") {
              window.open(redirectTo, "_blank");
            } else {
              window.location.href = redirectTo;
            }
          }, 1000);

        } else if (
          responseData.success === false &&
          responseData.message === 'enter_mobile'
        ) {
          setShowMobileVerification(true);
        } else {
          setLoginMessage(responseData.message || 'Google login failed');
          setBgColor('alert alert-danger');
          setShowAlert(true);
        }
      } catch (error) {
        setLoginMessage('Google login error');
        setBgColor('alert alert-danger');
        setShowAlert(true);
      }
    }
    if (code) {
      LoginHandle(code);
    }
  }, [location]);

  return (
    <div>
      {showMobileVerification===false?<Spining />:<MobileVerification jwt={token} method={"gmail_login"} />}
    </div>
  );
};

export default GoogleLogin;
